import { SavedSearchesEntity } from '@fund-base/types/saved-searches/constants/saved-searches.types';

export interface SavedSearchesState {
  savedSearches: SavedSearchesEntity[];
}

export const initialSavedSearchesState: SavedSearchesState = {
  savedSearches: [],
};
